import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminLayoutComponent } from './shared/layouts/admin/admin-layout.component';

const routes: Routes = [
  { path: '', redirectTo: '/notification', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('./domain/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/notification', pathMatch: 'full' },
      {
        path: 'demo',
        loadChildren: () =>
          import('./domain/demo/demo.module').then(m => m.DemoModule),
      },
      {
        path: 'notification',
        loadChildren: () =>
          import('./domain/notification/notification.module').then(
            m => m.NotificationModule,
          ),
      },
      {
        path: 'coupon',
        loadChildren: () =>
          import('./domain/coupon/coupon.module').then(m => m.CouponModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
